const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1;
const day = date.getDate();
const hours = date.getHours();
const minute = date.getMinutes();
const second = date.getSeconds();
module.exports = {
	// 月初
	currentMonthStart() {
		return `${year}-${month}-01`;
	},
	// 月末
	currentMonthEnd() {
		let datNum = new Date(year, month, 0).getDate();
		return `${year}-${month}-${datNum}`;
	},
	// 年初
	currentYearStart() {
		return `${year - 1}-01-01`;
	},
	// 年末
	currentYearEnd() {
		return `${year}-01-01`;
	},
	// 今日
	currentDate() {
		// month = month > 9 ? month : '0' + month;
		// day = day > 9 ? day : '0' + day;

		return `${year}-${month}-${day}`;
	},
	//30天
	currentDateEd() {
		// month = month > 9 ? month : '0' + month;
		// day = day > 9 ? day : '0' + day;
		let sada = new Date(date).getTime() - (1000 * 24 * 60 * 60 * 30)
		let dsa = new Date(sada)
		let years = dsa.getFullYear();
		let months = dsa.getMonth() + 1;
		let days = dsa.getDate();
		return `${years}-${months}-${days}`;
	},
	// 昨日
	Yesterday() {
		date.setTime(date.getTime() - 24 * 60 * 60 * 1000);
		return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
	},
	// 具体时间
	currentDateTime() {
		let months = month > 9 ? month : '0' + month;
		let days = day > 9 ? day : '0' + day;
		let hourss = hours > 9 ? hours : '0' + hours;
		let minutes = minute > 9 ? minute : '0' + minute;
		let seconds = second > 9 ? second : '0' + second;
		return `${year}-${months}-${days} ${hourss}:${minutes}:${seconds}`;
	},
	// 本周第一天
	showWeekFirstDay() {
		var Nowdate = new Date();
		var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);
		var M = Number(WeekFirstDay.getMonth()) + 1
		return WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();
	},
	// 本周最后一天
	showWeekLastDay() {
		var Nowdate = new Date();
		var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);
		var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
		var M = Number(WeekLastDay.getMonth()) + 1
		return WeekLastDay.getFullYear() + "-" + M + "-" + WeekLastDay.getDate();
	},
	// 获取上一周
	handleGetPrevWeek() {
		const Time = new Date()
		let weekNum = Time.getDay()
		weekNum = weekNum == 0 ? 7 : weekNum
		let lastDate = new Date(Time.getTime() - weekNum * 24 * 60 * 60 * 1000)
		let fitstDate = new Date(
			Time.getTime() - (weekNum + 6) * 24 * 60 * 60 * 1000
		)
		let startDate = `${fitstDate.getFullYear()}-${fitstDate.getMonth() + 1 < 10
				? '0' + (fitstDate.getMonth() + 1)
				: fitstDate.getMonth() + 1
			}-${fitstDate.getDate() < 10
				? '0' + fitstDate.getDate()
				: fitstDate.getDate()
			}`
		let endDate = `${lastDate.getFullYear()}-${lastDate.getMonth() + 1 < 10
				? '0' + (lastDate.getMonth() + 1)
				: lastDate.getMonth() + 1
			}-${lastDate.getDate() < 10 ? '0' + lastDate.getDate() : lastDate.getDate()
			}`
		return [startDate, endDate]
	},
	// 上月
	getMonth(num = 1) {
		if (num <= 0) return;
		let today = new Date();
		let year = today.getFullYear();//当前年份
		let need_year = year - Math.floor(num / 12);//获取到想要查询月所在的年份
		let need_year_next = need_year;//获取到想要查询月下一个月所在的年份
		let month = today.getMonth() + 1;//获取到当前月

		//获取num 的余数  如果余数大于等于当前月份  则年份还要减1
		let num_remainder = num % 12;
		if (num_remainder >= month) {
			need_year--;
			need_year_next--;
			month += 12;
		}

		//获取到所需要的月份和所需要的月份的下一个月
		let need_month = month - num_remainder;
		let need_month_next = need_month + 1;

		//如果所需要月份的下一个月大于12 则需要调到下一年的一月
		if (need_month_next > 12) {
			need_month_next = 1;
			need_year_next++;
		}
		if (need_month === 0) need_month = 12;
		//所需月份小于10 则前面补0
		if (need_month < 10) need_month = '0' + need_month;
		if (need_month_next < 10) need_month_next = '0' + need_month_next;
		return [`${need_year}-${need_month}-01`, `${need_year_next}-${need_month_next}-01`];
	},
	// 近三月
	getLast3Month() {
		var now = new Date();
		var year = now.getFullYear();
		var month = now.getMonth() + 1;//0-11表示1-12月
		var day = now.getDate();
		var dateObj = {};
		if (parseInt(month) < 10) {
			month = "0" + month;
		}
		if (parseInt(day) < 10) {
			day = "0" + day;
		}

		dateObj.now = year + '-' + month + '-' + day;

		if (parseInt(month) == 1) {//如果是1月份，则取上一年的10月份
			dateObj.last = (parseInt(year) - 1) + '-10-' + day;
			return dateObj;
		}
		if (parseInt(month) == 2) {//如果是2月份，则取上一年的11月份
			dateObj.last = (parseInt(year) - 1) + '-11-' + day;
			return dateObj;
		}
		if (parseInt(month) == 3) {//如果是3月份，则取上一年的12月份
			dateObj.last = (parseInt(year) - 1) + '-12-' + day;
			return dateObj;
		}

		var preSize = new Date(year, parseInt(month) - 3, 0).getDate();//开始时间所在月的总天数
		if (preSize < parseInt(day)) {
			// 开始时间所在月的总天数<本月总天数，比如当前是5月30日，在2月中没有30，则取下个月的第一天(3月1日)为开始时间
			let resultMonth = parseInt(month) - 2 < 10 ? ('0' + parseInt(month) - 2) : (parseInt(month) - 2);
			dateObj.last = year + '-' + resultMonth + '-01';
			return dateObj;
		}

		if (parseInt(month) <= 10) {
			dateObj.last = year + '-0' + (parseInt(month) - 3) + '-' + day;
			return dateObj;
		} else {
			dateObj.last = year + '-' + (parseInt(month) - 3) + '-' + day;
			return dateObj;
		}

	},
}